module.exports = __webpack_public_path__ + "img/widgets2.7d1389a0.png";